import React from "react";
import { ThemeProvider } from "styled-components";
import "./App.css";
import "./reset.css";
import theme from "./theme";
import { BrowserRouter } from "react-router-dom";
import { Route, Routes } from "react-router";
import Address from "./component/address/Address";
import CareTypeSelection from "./component/careTypeSelection/CareTypeSelection";
import Finish from "./component/finish/Finish";
import PhoneNumber from "./component/phoneNumber/PhoneNumber";
import Schedule from "./component/schedule/Schedule";
import Start from "./component/start/Start";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Start />} />
          <Route path="address" element={<Address />} />
          <Route path="care-type-selection" element={<CareTypeSelection />} />
          <Route path="finish" element={<Finish />} />
          <Route path="phone-number" element={<PhoneNumber />} />
          <Route path="schedule" element={<Schedule />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
